const storageKey = (userId: string) =>
  `karda-investigator-news-viewed:${encodeURIComponent(userId)}`;

export function getViewedNewsIds(userId: string): string[] {
  try {
    const stored: unknown = JSON.parse(
      window.localStorage.getItem(storageKey(userId)) ?? "[]"
    );
    return Array.isArray(stored)
      ? stored.filter((id): id is string => typeof id === "string")
      : [];
  } catch {
    // Corrupt or unavailable browser storage must not block the app.
    return [];
  }
}

export function markNewsAsViewed(userId: string, newsIds: readonly string[]) {
  try {
    const viewedIds = [...new Set([...getViewedNewsIds(userId), ...newsIds])];
    window.localStorage.setItem(storageKey(userId), JSON.stringify(viewedIds));
  } catch {
    // The modal also keeps dismissals in memory when storage is unavailable.
  }
}
